import { Modal } from "@mui/material";
import Image from "next/image";
import GoogleTranslationComponent from "../googleTranslate/GoogleTranslationComponent";
import { useTranslation } from "@/app/i18n/client";
import tycBackground from "@/assets/images/decorators/tyc-background.webp";
import Close from "@/assets/images/icons/close.svg";
import HexagonButton from "@/common/customElements/HexagonButton";
import { AbsoluteDiv } from "@/common/divs";
import { AlmostBoldText, LightText, SemiBoldText } from "@/common/texts";
import { ActivityTermsAndConditionsVm } from "@/model";
import { PRIMARY_BUTTON_COLOR } from "@/utils/constants";

const ModalTyc: React.FC<{
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  terms_and_conditions: ActivityTermsAndConditionsVm | undefined;
}> = ({ open, setOpen, terms_and_conditions }) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className="centerModal tyc-modal" style={{ overflow: "hidden" }}>
        <Image
          src={tycBackground}
          alt="background"
          width={555}
          height={1000}
          className="image-tyc"
          style={{
            height: "fit-content",
            width: "100%",
            objectFit: "cover",
            position: "fixed",
            zIndex: "-1",
          }}
        />

        <section className="modal-section-style" style={{ marginTop: "10px" }}>
          <AlmostBoldText fontSize="24px" style={{ justifyContent: "center" }}>
            {t("activity.legals.terms")}
          </AlmostBoldText>
          <AbsoluteDiv right="24px" top="24px">
            <HexagonButton
              onClick={() => setOpen(false)}
              width="32px"
              backgroundColor={PRIMARY_BUTTON_COLOR}
            >
              <Image
                alt="close"
                width="16"
                height="16"
                src={Close.src}
                style={{
                  position: "absolute",
                  top: "20%",
                  left: "27%",
                }}
              />
            </HexagonButton>
          </AbsoluteDiv>
        </section>
        {terms_and_conditions && (
          <section
            className="mini-modal-section"
            style={{ marginTop: "20px", maxHeight: "70vh", overflowY: "auto" }}
          >
            <>
              <SemiBoldText fontSize="18px">
                {t("activity.legals.terms")}
              </SemiBoldText>
              {(
                terms_and_conditions.termsAndConditionsPolicy?.description &&
                terms_and_conditions.termsAndConditionsPolicy?.description[0] ==
                  "["
              ) ?
                JSON.parse(
                  terms_and_conditions.termsAndConditionsPolicy?.description,
                ).map((item: any, index: number) => (
                  <LightText key={index} style={{ marginTop: "8px" }}>
                    •{" "}
                    <GoogleTranslationComponent
                      text={item.children[0].text ?? ""}
                    />
                  </LightText>
                ))
              : <LightText style={{ marginTop: "8px" }}>
                  • {terms_and_conditions.termsAndConditionsPolicy?.description}
                </LightText>
              }

              <>
                <SemiBoldText fontSize="18px" style={{ marginTop: "8px" }}>
                  {t("activity.legals.cancellation")}
                </SemiBoldText>
                {(
                  terms_and_conditions.cancellationPolicy?.description &&
                  terms_and_conditions.cancellationPolicy?.description[0] == "["
                ) ?
                  JSON.parse(
                    terms_and_conditions.cancellationPolicy?.description,
                  ).map((item: any, index: number) => (
                    <LightText key={index} style={{ marginTop: "8px" }}>
                      •{" "}
                      <GoogleTranslationComponent
                        text={item.children[0].text ?? ""}
                      />
                    </LightText>
                  ))
                : <LightText style={{ marginTop: "8px" }}>
                    •{" "}
                    <GoogleTranslationComponent
                      text={
                        terms_and_conditions.cancellationPolicy?.description ??
                        ""
                      }
                    />
                  </LightText>
                }
                <SemiBoldText fontSize="18px" style={{ marginTop: "8px" }}>
                  {t("activity.legals.reservation")}
                </SemiBoldText>
                {(
                  terms_and_conditions.reservationPolicy?.description &&
                  terms_and_conditions.reservationPolicy?.description[0] == "["
                ) ?
                  JSON.parse(
                    terms_and_conditions.reservationPolicy?.description,
                  ).map((item: any, index: number) => (
                    <LightText key={index} style={{ marginTop: "8px" }}>
                      •{" "}
                      <GoogleTranslationComponent
                        text={item.children[0].text ?? ""}
                      />
                    </LightText>
                  ))
                : <LightText style={{ marginTop: "8px" }}>
                    •{" "}
                    <GoogleTranslationComponent
                      text={
                        terms_and_conditions.reservationPolicy?.description ??
                        ""
                      }
                    />
                  </LightText>
                }
              </>
            </>
          </section>
        )}
      </div>
    </Modal>
  );
};

export default ModalTyc;
